import gql from 'graphql-tag';

export const RECHECK_COMPLYCUBE_WATCHLIST = gql`
    mutation recheckComplycubeWatchlist($input: RecheckWatchlistInput!) {
      recheckComplycubeWatchlist(input: $input)
    }
`;
